<template>
  <v-dialog :value="value" persistent max-width="800px">
    <nv-form
      v-if="item != null"
      :errors="formErrors"
      :title="formTitle"
      :loading="loading"
      @cancel="formCancel"
      @nv-submit="formSubmit"
    >
      <v-row dense>
        <v-col cols="12">
          <v-text-field
            v-model="item.name"
            :rules="rules.name"
            :disabled="!!editing"
            data-cy="sdk-name"
            label="Name"
            hint="The parameter name"
            counter="128"
            required
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            ref="value"
            v-model="item.value"
            :rules="rules.value"
            label="Value"
            hint="The parameter value"
            counter="400"
            required
          />
        </v-col>
        <v-col cols="12">
          <v-text-field
            ref="description"
            v-model="item.description"
            :rules="rules.description"
            label="Description"
            hint="A helpful description"
            counter="255"
          />
        </v-col>
        <v-col v-if="!!editing" cols="12" sm="6">
          <v-select
            v-model="item.status"
            :rules="rules.status"
            :items="enumSDKStatuses"
            label="Status"
            required
            multi-line
          />
        </v-col>
      </v-row>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/dog';
import { FormMixin, enumFetch } from '@nielsen-media/ui-toolkit-vue-api';
import { rules } from './validations';

export default {
  mixins: [FormMixin],
  data: () => ({
    enumSDKStatuses: [],
    rules,
    formContext: 'SDK Configuration',
    originalItem: null,
  }),
  created() {
    this.enumFetch(HTTP, {
      enumSDKStatuses: '/sdks/configuration/enum/statuses',
    });
  },
  methods: {
    formReady() {
      this.originalItem = JSON.parse(JSON.stringify(this.editing || {}));
    },
    formSave() {
      const updatedItem = {
        ...this.originalItem,
        name: this.item.name,
        value: this.item.value,
        description: this.item.description,
        status: this.item.status || 'active',
      };
      this.$emit('saved', updatedItem);
      this.formCancel();
      return Promise.resolve();
    },
    enumFetch,
  },
};
</script>
